import { render, staticRenderFns } from "./ApproveRF.vue?vue&type=template&id=c70464b2"
import script from "./ApproveRF.vue?vue&type=script&lang=js"
export * from "./ApproveRF.vue?vue&type=script&lang=js"
import style0 from "./ApproveRF.vue?vue&type=style&index=0&id=c70464b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports